export default __webpack_public_path__ + "static/media/delete-icon.6142ff4a.svg";